Classify only after comparing the failed assertion, captured application state,
source, history, and a focused rerun.

Application bug:
  The expected behavior is correct, the app state contradicts it, and the same
  scenario fails reproducibly without lifecycle disruption.

Test issue:
  The assertion/selector/test data is stale or incorrect, or source review shows
  the test expects behavior the product no longer promises.

Harness issue:
  The runner never reached the assertion reliably: timeout, bootstrap/collection
  failure, missing/truncated results, environment unavailability, or a failure
  that disappears when the identical scenario reruns after infrastructure
  recovery.

Inconclusive:
  Evidence is missing or conflicting. State what is known, preserve the
  workspace, and run the smallest experiment that can separate the remaining
  hypotheses. Never convert “passed on retry” directly into “test issue”; it may
  be application flakiness or environmental instability.
